export const generalTasksList = [
  {
    key: 'checklistSent',
    name: 'Checklist Sent (Dependency checklist email)',
    role: 'PM',
    dependencies: [],
    id: 1,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'receivedDependencies',
    name: 'Received Dependencies',
    role: 'PM',
    dependencies: ['checklistSent'],
    id: 2,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'verifyDependencies',
    name: 'Verify Dependencies',
    role: 'PM',
    dependencies: ['checklistSent', 'receivedDependencies'],
    id: 3,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'createAccountShells',
    name: 'Create Account Shells',
    role: 'MIA',
    dependencies: ['verifyDependencies'],
    id: 4,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'creativeTasksSent',
    name: 'Creative Tasks Sent',
    role: 'PM',
    dependencies: ['verifyDependencies'],
    id: 5,
    relatedDealField: 'onboardingProgress',
    subTask: true,
  },
  {
    key: 'integrationsStep',
    name: 'Integrations',
    role: 'MIA',
    dependencies: ['verifyDependencies'],
    id: 6,
    relatedDealField: 'onboardingProgress',
    subTask: true,
  },
  {
    key: 'searchCampaignCreation',
    name: 'Search Campaign Creation',
    role: 'DMS',
    dependencies: ['integrationsStep'],
    id: 7,
    relatedDealField: 'onboardingProgress',
    subTask: true,
  },
  {
    key: 'createSocialDisplayCampaigns',
    name: 'Create Social/Display Campaigns',
    role: 'DMS',
    dependencies: ['integrationsStep'],
    id: 8,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'campaignQuality',
    name: 'Campaign Quality',
    role: 'DMS',
    dependencies: ['createSocialDisplayCampaigns'],
    id: 9,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'launchCampaigns',
    name: 'Launch Campaigns',
    role: 'DMS',
    dependencies: ['campaignQuality'],
    id: 10,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'handoffCall',
    name: 'Handoff Call',
    role: 'PM',
    dependencies: ['launchCampaigns'],
    id: 11,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'completeSeoForm',
    name: 'Complete Seo Form',
    role: 'SEO',
    dependencies: ['launchCampaigns'],
    id: 12,
    relatedDealField: 'onboardingProgress',
  },
  {
    key: 'loginCredentials',
    name: 'SEO Login Credentials',
    role: 'SEO',
    dependencies: ['launchCampaigns'],
    id: 13,
    relatedDealField: 'onboardingProgress',
  },
  // {
  //   key: 'firstReportingCall',
  //   name: 'First Reporting Call',
  //   role: 'AM',
  //   dependencies: ['handoffCall'],
  //   id: 14,
  //   relatedDealField: 'onboardingProgress',
  // },
  // {
  //   key: 'tapclicksSetup',
  //   name: 'Tapclicks Setup',
  //   role: 'AM',
  //   dependencies: ['firstReportingCall'],
  //   id: 15,
  //   relatedDealField: 'onboardingProgress',
  // },
]

const onboardingChecklist = [
  { key: 'checklistSent', name: 'Checklist Sent (Dependency checklist email)' },
  { key: 'receivedDependencies', name: 'Received Dependencies' },
  { key: 'verifyDependencies', name: 'Verify Dependencies' },
  { key: 'createAccountShells', name: 'Create Account Shells' },
  { key: 'creativeTasksSent', name: 'Creative Tasks Sent' },
  { key: 'integrationsStep', name: 'Integrations' },
  { key: 'searchCampaignCreation', name: 'Search Campaign Creation' },
  { key: 'createSocialDisplayCampaigns', name: 'Create Social/Display Campaigns' },
  { key: 'campaignQuality', name: 'Campaign Quality' },
  { key: 'launchCampaigns', name: 'Launch Campaigns' },
  { key: 'handoffCall', name: 'Handoff Call' },
  { key: 'completeSeoForm', name: 'Complete Seo Form' },
  { key: 'loginCredentials', name: 'SEO Login Credentials' },
]
export const premiumWebsiteList = [
  {
    key: 'domainAcquisition',
    name: 'Domain Acquisition',
    id: 1,
  },
  {
    key: 'contentVerification',
    name: 'Content Verification',
    id: 2,
  },
  {
    key: 'setupDevSite',
    name: 'Setup Dev Site',
    id: 3,
  },
  {
    key: 'homepageBuild',
    name: 'Homepage Build',
    id: 4,
  },
  {
    key: 'homepageRevisions',
    name: 'Homepage Revisions',
    id: 5,
  },
  {
    key: 'subpagesBuild',
    name: 'Subpages Build',
    id: 6,
  },
  {
    key: 'subpageRevisions',
    name: 'Subpage Revisions',
    id: 7,
  },
  {
    key: 'qualityAssuranceChecks',
    name: 'Quality Assurance Checks',
    id: 8,
  },
  {
    key: 'cutoverToLiveDomain',
    name: 'Cutover to live domain',
    id: 9,
  },
]
export const newWebsiteList = [
  {
    key: 'key_1',
    name: 'Domain Acquisition',
    id: 1,
  },
  {
    key: 'key_2',
    name: 'Content Verification',
    id: 2,
  },
  {
    key: 'key_3',
    name: 'Setup Live Domain for Development',
    id: 3,
  },
  {
    key: 'key_4',
    name: 'Homepage + Coming Soon page Build',
    id: 4,
  },
  {
    key: 'key_5',
    name: 'Subpage Revisions',
    id: 5,
  },
  {
    key: 'key_6',
    name: 'Subpages Build',
    id: 6,
  },
  {
    key: 'key_7',
    name: 'Subpage Revisions',
    id: 7,
  },
  {
    key: 'key_8',
    name: 'Quality Assurance Checks',
    id: 8,
  },
  {
    key: 'key_9',
    name: 'Cutover to live domain',
    id: 9,
  },
]
export const logoTaskList = [
  {
    key: 'namingBrainstorming',
    name: 'Naming/Brainstorming',
    id: 1,
  },
  {
    key: 'firstRoundLogoCreationMultipleDesigns',
    name: 'First Round Logo Creation (Multiple Designs)',
    id: 2,
  },
  {
    key: 'creativePanelReview',
    name: 'Creative Panel Review',
    id: 3,
  },
  {
    key: 'reviewSelections',
    name: 'Review Selections',
    id: 4,
  },
  {
    key: 'brandPDFCreation',
    name: 'Brand PDF Creation',
    id: 5,
  },
  {
    key: 'clientReview',
    name: 'Client Review',
    id: 6,
  },
  {
    key: 'clientFeedbackRevisions',
    name: 'Client Feedback/Revisions',
    id: 7,
  },
  {
    key: 'reviseBrandPDF',
    name: 'Revise Brand PDF',
    id: 8,
  },
  {
    key: 'clientReviewRevisions',
    name: 'Client Review (After Revisions)',
    id: 9,
  },
]
export const brandingGuideTaskList = [
  {
    key: 'assembleWorkIntoBrandTemplate',
    name: 'Assemble work into Brand Template',
    id: 1,
  },
  {
    key: 'brandMessaging',
    name: 'Brand Messaging',
    id: 2,
  },
  {
    key: 'brandPatterns',
    name: 'Brand Patterns',
    id: 3,
  },
  {
    key: 'brandPhotography',
    name: 'Brand Photography',
    id: 4,
  },
]
export const fullBrandList = [
  {
    key: 'namingBrainstorming',
    name: 'Naming/Brainstorming',
    id: 1,
  },
  {
    key: 'firstRoundLogoCreationMultipleDesigns',
    name: 'First Round Logo Creation (Multiple Designs)',
    id: 2,
  },
  {
    key: 'creativePanelReview',
    name: 'Creative Panel Review',
    id: 3,
  },
  {
    key: 'reviewSelections',
    name: 'Review Selections',
    id: 4,
  },
  {
    key: 'brandPDFCreation',
    name: 'Brand PDF Creation',
    id: 5,
  },
  {
    key: 'clientReview',
    name: 'Client Review',
    id: 6,
  },
  {
    key: 'clientFeedbackRevisions',
    name: 'Client Feedback/Revisions',
    id: 7,
  },
  {
    key: 'reviseBrandPDF',
    name: 'Revise Brand PDF',
    id: 8,
  },
  {
    key: 'clientReviewFinal',
    name: 'Client Review (Final)',
    id: 9,
  },
]
export const photoVideoTravelTaskList = [
  {
    key: 'scheduleShoot',
    name: 'Schedule Shoot',
    id: 1,
  },
  {
    key: 'travelAcommodationsIfApplicable',
    name: 'Travel/Acommodations (if applicable)',
    id: 2,
  },
  {
    key: 'bookModels',
    name: 'Book Models\t',
    id: 3,
  },
  {
    key: 'shootPrep',
    name: 'Shoot Prep\t',
    id: 4,
  },
  {
    key: 'showUpSetUp',
    name: 'Show up/Set up',
    id: 5,
  },
  {
    key: 'shoot',
    name: 'Shoot\t',
    id: 6,
  },
  {
    key: 'transferFootage',
    name: 'Transfer Footage',
    id: 7,
  },
  {
    key: 'cullingPhotos',
    name: 'Culling Photos',
    id: 8,
  },
  {
    key: 'edit',
    name: 'Edit',
    id: 9,
  },
  {
    key: 'sendToAMPMBDE',
    name: 'Send to AM/PM/BDE',
    id: 10,
  },
]
export const photoVideoLocalTaskList = [
  {
    key: 'scheduleShoot',
    name: 'Schedule Shoot',
    id: 1,
  },
  {
    key: 'showUpSetUp',
    name: 'Show up/Set up',
    id: 2,
  },
  {
    key: 'shootPrepShoot',
    name: 'Shoot Prep\tShoot',
    id: 3,
  },
  {
    key: 'transferFootageEdit',
    name: 'Transfer Footage/Edit',
    id: 4,
  },
  {
    key: 'sendToAMPMBDE',
    name: 'Send to AM/PM/BDE',
    id: 5,
  },
]
export const shootEquipmentChecklist = [
  {
    key: 'bothCameras',
    name: 'Both Cameras',
    id: 1,
  },
  {
    key: 'cameraBags',
    name: 'Camera Bags',
    id: 2,
  },
  {
    key: 'memoryCardsWiped',
    name: 'Memory Cards wiped',
    id: 3,
  },
  {
    key: 'allBatteriesCharged',
    name: 'All Batteries Charged',
    id: 4,
  },
  {
    key: 'flash',
    name: 'Flash',
    id: 5,
  },
  {
    key: 'extraBatteriesForFlash',
    name: 'Extra Batteries for Flash',
    id: 6,
  },
  {
    key: 'shotListLocationIdeas',
    name: 'Shot List/Location/Ideas',
    id: 7,
  },
  {
    key: 'tripodsIfNecessary',
    name: 'Tripods if necessary',
    id: 8,
  },
  {
    key: 'lightequipmentIfNecessary',
    name: 'Light/equipment if necessary',
    id: 9,
  },
  {
    key: 'drone',
    name: 'Drone',
    id: 10,
  },
  {
    key: 'droneBatteriesCharged',
    name: 'Drone batteries Charged',
    id: 11,
  },
  {
    key: 'droneUpdated',
    name: 'Drone updated',
    id: 12,
  },
  {
    key: 'controllerCharged',
    name: 'Controller Charged',
    id: 13,
  },
  {
    key: 'memoryCardWiped',
    name: 'Memory Card Wiped',
    id: 14,
  },
]
export const createCampaignTaskList = [
  {
    key: 'namingBrainstorming',
    name: 'Naming/Brainstorming',
    id: 1,
  },
  {
    key: 'ideationIfApplicable',
    name: 'Ideation (If applicable)',
    id: 2,
  },
  {
    key: 'creativeExampleFontsPatternsColorsEtc',
    name: 'Creative Example (Fonts, Patterns, Colors, etc.',
    id: 3,
  },
  {
    key: 'clientReview',
    name: 'Client Review',
    id: 4,
  },
  {
    key: 'designCollateral',
    name: 'Design Collateral',
    id: 5,
  },
  {
    key: 'feebackRevisions',
    name: 'Feeback/Revisions',
    id: 6,
  },
]
export const collateralTaskList = [
  {
    key: 'mockupEnvelopes',
    name: 'Mock-up: Envelopes',
    id: 1,
  },
  {
    key: 'mockupBusinessCards',
    name: 'Mock-up: Business Cards',
    id: 2,
  },
  {
    key: 'mockupLetterhead',
    name: 'Mock-up: Letterhead',
    id: 3,
  },
  {
    key: 'mockupSocialCoverPhotoFBXLinkedin',
    name: 'Mock-up: Social Cover Photo (FB, X, Linkedin)',
    id: 4,
  },
  {
    key: 'mockupBusinessProfilePictureForSocial',
    name: 'Mock-up: Business Profile Picture for Social',
    id: 5,
  },
]
export const amTaskList = [
  {
    key: 'checkInEmail',
    name: 'Bi-Weekly check in email',
    id: 1,
  },
  {
    key: 'reportingCall',
    name: 'Reporting Call',
    id: 2,
  },
  {
    key: 'budgetAudits',
    name: 'Budget Audits',
    id: 3,
  },
  // {
  //   key: 'leasingPercentageLog',
  //   name: 'Leasing Percentage Log',
  //   id: 4,
  // },
]
export const dmsTaskList = [
  {
    key: 'optOrObserveCreated',
    name: 'Observation/Optimization Made',
    id: 1,
  },
  {
    key: 'budgetAudits',
    name: 'Budget Audits',
    id: 2,
  },
  {
    key: 'insightsReportingCall',
    name: 'Insights for AM Reporting Call',
    id: 3,
  },
]
export const rmsaBypassTasklist = [
  {
    key: 'adCopyChk',
    name: 'Ad copy',
    id: 1,
  },
  {
    key: 'creativesCopyChk',
    name: 'Creative copy OK',
    id: 2,
  },
  {
    key: 'placementChk',
    name: 'Creatives are placed properly/correctly and the correct sizing.',
    id: 3,
  },
  {
    key: 'urlConfirm',
    name: 'URL(s) confirmed working',
    id: 4,
  },
]
export const adApprovalsTasklist = [
  {
    key: 'adCopyChk',
    name: 'Ad copy',
    id: 1,
  },
  {
    key: 'creativesCopyChk',
    name: 'Creative copy OK',
    id: 2,
  },
  {
    key: 'placementChk',
    name: 'Creatives are placed properly/correctly and the correct sizing.',
    id: 3,
  },
  {
    key: 'urlConfirm',
    name: 'URL(s) confirmed working',
    id: 4,
  },
]
export const seoTier2TaskList = [
  {
    key: 'correctGTMGA4',
    name: 'Confirm Correct GTM & GA4 on client website',
    id: 1,
  },
  {
    key: 'confirmGoalsConversions',
    name: 'Confirm Goals & Conversions in GA4',
    id: 2,
  },
  {
    key: 'webmasterVerify',
    name: 'Google/Bing Webmasters Verification/Submission',
    id: 3,
  },
  {
    key: 'robotsTxt',
    name: 'Set up Robots.txt File',
    id: 4,
  },
  {
    key: 'sitemapSubmission',
    name: 'Sitemap Submission and Addition to Robots.txt',
    id: 5,
  },
  {
    key: 'googleWebmastersLink',
    name: 'Link Google Webmasters and GA4 to SEranking',
    id: 6,
  },
  {
    key: 'vendastaBusListingDist',
    name: 'Vendasta - Business Listing Distribution',
    id: 7,
  },
  {
    key: 'vendastaBusListingSync',
    name: 'Vendasta - Business Listing Sync Pro',
    id: 8,
  },
  {
    key: 'requestAccessGMB',
    name:
      "Request access to client's GMB. If client has no access, start creation/claim Google listing. (this task is completed in onboarding once request/creation/claim has been initiated)",
    id: 9,
  },
  {
    key: 'clientInfoSE',
    name: 'Enter Client into SE Ranking',
    id: 10,
  },
  {
    key: 'seoAudit',
    name: 'Perform SEO Audit in SEranking',
    id: 11,
  },
  {
    key: 'formFillTest',
    name: 'Perform a Form Fill Test',
    id: 12,
  },
  {
    key: 'keywordResearch',
    name: 'Keyword Research',
    id: 13,
  },
  {
    key: 'newLaunchCheck',
    name: "If Newly Launched Check 301's",
    id: 14,
  },
  {
    key: 'auditKeywordNotes',
    name: 'Provide SEO Audit, Keyword Research and Onboarding Notes for AM in Monday',
    id: 15,
  },
]
export const metaCampaignCreationList = [
  {
    key: 'campaignStructureDocument',
    name: 'Campaign Structure document',
    id: 1,
  },
  {
    key: 'remarketingAudienceCreated',
    name: 'Remarketing Audience created',
    id: 2,
  },
  {
    key: 'pageLinked',
    name: 'Page Linked',
    id: 3,
  },
  {
    key: 'urlUtm',
    name: 'URL/UTM',
    id: 4,
  },
  {
    key: 'adsOptimizedForPlacements',
    name: 'Ads Optimized for Placements',
    id: 5,
  },
  {
    key: 'adsApprovedSpellingChecked',
    name: 'Ads Approved/ Spelling checked',
    id: 6,
  },
  {
    key: 'websiteEventsCheckMarked',
    name: 'Website Events Check Marked',
    id: 7,
  },
  {
    key: 'customConversionsCreated',
    name: 'Custom Conversions Created',
    id: 8,
  },
  {
    key: 'shapeSetup',
    name: 'Shape Setup',
    id: 9,
  },
  {
    key: 'budgetCorrect',
    name: 'Budget Correct',
    id: 10,
  },
]
export const simplifiCampaignCreationList = [
  {
    key: 'createSimplifiCampaign',
    name: 'Simplifi Campaign Creation',
    id: 1,
  },
]
export const googleDisplayCampaignCreationList = [
  {
    key: 'createGoogleDisplayCampaign',
    name: 'Google Display Campaign Creation',
    id: 1,
  },
]
export const googleSearchCampaignCreationList = [
  {
    key: 'createGoogleSearchCampaign',
    name: 'Google Search Campaign Creation',
    id: 1,
  },
]
export const metaCampaignCreationSubtaskList = [
  {
    key: 'createMetaCampaign',
    name: 'Meta Campaign Creation',
    id: 1,
  },
]
export const genericCampaignCreationList = [
  {
    key: 'createCampaign',
    name: 'Create Campaign',
    id: 1,
  },
]
export const seoMonthlyTaskList = [
  {
    id: 1,
    key: 'siteAudit',
    name: `Site Audit / Crawl`,
    role: 'SEO',
    dependencies: [],
    status: 'In Progress',
    relatedDealField: 'monthlySEO',
    relatedOrgField: 'monthlySEO',
  },
  {
    id: 2,
    key: 'optsPerformed',
    name: `Opts Performed`,
    role: 'SEO',
    dependencies: [],
    status: 'In Progress',
    relatedDealField: 'monthlySEO',
    relatedOrgField: 'monthlySEO',
  },
]
